import React, { useState } from "react";
import UserLoanitem from "./user_loan_item";
import { Link } from "react-router-dom";
import Chart from "react-apexcharts";
import { useWindowSize } from "react-use";

import "./investment_container.css";

const numberWithCommas = (x) => {
  try {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } catch {
    return 0;
  }
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }
  render() {
    if (this.state.errorInfo) {
      return <div></div>;
    }
    return this.props.children;
  }
}

export function numerizeFloat(value) {
  return [value["timestamp"], +value["value"]];
}

const Investmentcontainer = (props) => {
  let bal = [[100000, 0]];
  bal = props.data.tsBalance;

  let bali = [[100000, 0]];
  bali = props.data.inBalance;

  try {
    bal.push({ timestamp: props.data.ts, value: props.data.balance });
  } catch {}

  try {
    bali.push({ timestamp: props.data.ts, value: props.data.investedBalance });
  } catch {}

  try {
    bal = bal.map(numerizeFloat);
  } catch {
    bal = [[100000, 0]];
    bal = bal.map(numerizeFloat);
  }

  try {
    bali = bali.map(numerizeFloat);
  } catch {
    bali = [[100000, 0]];
    bali = bali.map(numerizeFloat);
  }

  let tmp = [];
  if (bal.length == 0) {
    tmp = [[1000, 0.1]];
  } else {
    tmp = bal;
  }

  let tmpi = [];
  if (bali.length == 0) {
    tmpi = [[1000, 0.1]];
  } else {
    tmpi = bali;
  }

  let apex_data = [
    { name: "Available", data: tmp },
    { name: "Invested", data: tmpi },
  ];

  let apex_i_data = [{ data: tmpi }];

  let { width, height } = useWindowSize();
  if (width > 565) {
    width = 565;
  } else {
    width = width - 55;
  }

  let apex_options = {
    colors: ["#91b673ff", "#c2a764ff"],
    yaxis: {
      labels: {
        show: true,
        formatter: function (val) {
          return ~~val / 1000 + "k";
        },
      },
    },
    xaxis: {
      type: "datetime",
      tickAmount: 8,
      labels: {
        show: false,
      },
    },
    chart: {
      id: "area-datetime",
      type: "area",
      animations: {
        enabled: false,
        dynamicAnimation: {
          enabled: false,
        },
      },
      stacked: true,
      zoom: {
        autoScaleYaxis: true,
      },
      toolbar: {
        show: false,
      },
      tooltip: {
        shared: true,
      },
    },

    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },
    tooltip: {
      shared: true,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0.0,
        stops: [0, 100],
        gradientToColors: ["#91b673ff", "#c2a764ff"],
      },
    },
  };

  var _d = new Date(props.data.subscriptionValidity);
  let _F = [];
  let counter = 0;
  try {
    props.loans.map((loan) => {
      if (counter == 0) {
        _F.push(<UserLoanitem data={loan} key={loan.id}></UserLoanitem>);
        counter = 1;
      }
    });
  } catch {}

  const chenge_fee = () => {
    if (props.fee == "REQSUB") {
      props.setFee("NONE");
    } else {
      props.setFee("REQSUB");
    }
  };

  return (
    <div className='investmentcontainer-investmentcontainer'>
      <Link to={"/cbm_user_all_loans/" + props.entity_uid} style={{ width: "100%" }}>
        <div className='investmentcontainer-container'>
          <ErrorBoundary>
            <Chart options={apex_options} series={apex_data} type='area' height='100%' width={width} />
          </ErrorBoundary>
        </div>
        <div className='investmentcontainer-container1'>
          <div className='investmentcontainer-container2'>
            <span className='investmentcontainer-text'>Available Balance:</span>
            <span className='investmentcontainer-text1'>{numberWithCommas(props.data.balance) + " VT"}</span>
          </div>
          <div className='investmentcontainer-container3'>
            <span className='investmentcontainer-text2'>Invested Balance:</span>
            <span className='investmentcontainer-text3'>{numberWithCommas(props.data.investedBalance) + " VT"}</span>
          </div>
          <div className='investmentcontainer-container4'>
            <span className='investmentcontainer-text4'>Total</span>
            <span className='investmentcontainer-text5'>{numberWithCommas(props.data.investedBalance + props.data.balance) + " VT"}</span>
          </div>
        </div>
        {props.data.isValid == true ? (
          <span className='investmentcontainer-text6'>{"Valid until: " + _d.toISOString().split("T")[0]}</span>
        ) : (
          <span className='investmentcontainer-text7'>{"Invalid since: " + _d.toISOString().split("T")[0]}</span>
        )}
      </Link>

      {(props.containerType == "MAIN") & (props.data.loans == true) ? (
        <>
          <span className='entityeditor-text2'>{"Active Loan"}</span>
          <Link
            to={
              "/cbm_user_loan/" +
              props.loans[0].id +
              "/" +
              props.entity_uid +
              "/" +
              props.loans[0].debtAccount[0].accountNo +
              "/" +
              props.loans[0].createdBy
            }
            style={{ width: "100%", paddingLeft: "16px", paddingRight: "16px" }}>
            {_F}
          </Link>
        </>
      ) : (
        <></>
      )}
      {props.containerType !== "MAIN" && (
        <div className='investmentcontainer-container5'>
          <svg viewBox='0 0 1024 1024' className='investmentcontainer-icon' onClick={chenge_fee}>
            <path d='M438.857 658.286h219.429v-54.857h-73.143v-256h-65.143l-84.571 78.286 44 45.714c13.714-12 22.286-18.286 31.429-32.571h1.143v164.571h-73.143v54.857zM731.429 512c0 104-62.857 237.714-182.857 237.714s-182.857-133.714-182.857-237.714 62.857-237.714 182.857-237.714 182.857 133.714 182.857 237.714zM1024 658.286v-292.571c-80.571 0-146.286-65.714-146.286-146.286h-658.286c0 80.571-65.714 146.286-146.286 146.286v292.571c80.571 0 146.286 65.714 146.286 146.286h658.286c0-80.571 65.714-146.286 146.286-146.286zM1097.143 182.857v658.286c0 20-16.571 36.571-36.571 36.571h-1024c-20 0-36.571-16.571-36.571-36.571v-658.286c0-20 16.571-36.571 36.571-36.571h1024c20 0 36.571 16.571 36.571 36.571z'></path>
          </svg>
          <svg viewBox='0 0 1024 1024' className='investmentcontainer-icon2' style={{ display: "none" }}>
            <path d='M853.333 640v170.667c0 11.776-4.736 22.4-12.501 30.165s-18.389 12.501-30.165 12.501h-597.333c-11.776 0-22.4-4.736-30.165-12.501s-12.501-18.389-12.501-30.165v-170.667c0-23.552-19.115-42.667-42.667-42.667s-42.667 19.115-42.667 42.667v170.667c0 35.328 14.379 67.413 37.504 90.496s55.168 37.504 90.496 37.504h597.333c35.328 0 67.413-14.379 90.496-37.504s37.504-55.168 37.504-90.496v-170.667c0-23.552-19.115-42.667-42.667-42.667s-42.667 19.115-42.667 42.667zM469.333 230.997v409.003c0 23.552 19.115 42.667 42.667 42.667s42.667-19.115 42.667-42.667v-409.003l140.501 140.501c16.683 16.683 43.691 16.683 60.331 0s16.683-43.691 0-60.331l-213.333-213.333c-4.096-4.096-8.789-7.168-13.824-9.259s-10.539-3.243-16.341-3.243c-5.547 0-11.136 1.067-16.341 3.243-5.035 2.091-9.728 5.163-13.824 9.259l-213.333 213.333c-16.683 16.683-16.683 43.691 0 60.331s43.691 16.683 60.331 0z'></path>
          </svg>
          <div className='investmentcontainer-container6'></div>
          <Link to={"/wallet/" + props.data.madruhamAccount}>
            <svg viewBox='0 0 1024 1024' className='investmentcontainer-icon4'>
              <path d='M250 176l92-90 426 426-426 426-92-90 338-336z'></path>
            </svg>
          </Link>
        </div>
      )}
    </div>
  );
};

export default Investmentcontainer;
